import {Component, Input, OnInit} from '@angular/core';
import {TranslationValue} from '../../generated/sales-terminal-client';
import {LanguageService} from '../../services/language/language.service';
import {AuthService} from '../../services/auth/auth.service';

@Component({
  selector: 'app-translation-tabs',
  templateUrl: './translation-tabs.component.html',
  styleUrls: ['./translation-tabs.component.scss']
})
export class TranslationTabsComponent implements OnInit {
  @Input() public title: string;
  @Input() public header: boolean;
  @Input() public translationValues: TranslationValue[] = [];
  @Input() public htmlValues: boolean;

  constructor(private languageService: LanguageService,
              private authService: AuthService) {}

  public ngOnInit(): void {
    this.translationValues = this.languageService
      .sortWebShopLanguagesForTranslations(this.translationValues, this.authService.salesPointLanguage);
  }

  public get hasValues(): boolean {
    return this.translationValues?.length && this.translationValues.some(translation => translation.value?.length);
  }
}
